import { z } from 'zod/v3';
import { BaseAction } from '../../actions/framework/action.base';
import {
  ActionResult,
  ApplicableContext,
  ExecuteContext,
} from '../../actions/framework';
import { DataGridModel } from '../model';
import { ok } from 'neverthrow';
import { CoteraDuckDB } from '@cotera/client/app/etc';
import { Assert } from '@cotera/utilities';
import {
  downloadFile,
  jsonToCsv,
} from '@cotera/client/app/components/utils/utils';
import { toast } from '@cotera/client/app/components/ui';
import { DuckDBQueryResult } from '@cotera/client/app/etc/duckdb';

export class DownloadCsvAction extends BaseAction<{}, { t: string }[]> {
  title = 'Download CSV';
  inputSchema = z.object({});
  group = 'Data Grid';
  icon = 'download';

  constructor(private readonly db: Promise<CoteraDuckDB>) {
    super();
  }

  applicable(context: ApplicableContext): boolean {
    return context.hasTargetedModelOfType(DataGridModel);
  }

  async execute(
    _: {},
    context: ExecuteContext
  ): Promise<ActionResult<{ t: string }[]>> {
    const dataGrid = context.targetedModelOfType(DataGridModel);

    Assert.assert(dataGrid !== null);

    const toastController = toast.loading('Downloading CSV...');

    const db = await this.db;
    const dataRel = dataGrid.dataRel.snapshot();
    const arrowTable = await db.query(dataRel);
    const queryResult = new DuckDBQueryResult(arrowTable, dataRel.attributes);

    // Get visible columns from the data grid model
    const columns = dataGrid.columns.snapshot();
    const visibleColumns = columns
      .filter((col) => col.status === 'visible')
      .map((col) => col.key);

    const filteredData = queryResult.toArray({
      selectedColumns: visibleColumns,
    });

    const csv = await jsonToCsv(filteredData);

    downloadFile([csv], 'csv');

    toastController.success('CSV downloaded');

    return ok({});
  }
}
